import FileGenerator from '@/components/entities/patient/views/FileGenerator';

const HSTFileGenerator = FileGenerator('hst', 'HST');

export default HSTFileGenerator;
